import React, { Component } from 'react'
import { TxBottom } from '../../../../components'

class AddressInternalTransactions extends Component {
    render() {
        return <TxBottom {...this.props} />
    }
}

export default AddressInternalTransactions
